"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationMethodBase = void 0;
var ExpressionEvaluator_1 = require("../ExpressionEvaluator");
var ValidationMethodBase = /** @class */ (function () {
    function ValidationMethodBase(commandsExecutor) {
        this.commandsExecutor = commandsExecutor;
    }
    ValidationMethodBase.prototype.validate = function (input, context) {
        var validationResult = this.validateInput(input, context);
        if (this.commandsExecutor) {
            if (validationResult.valid) {
                this.commandsExecutor.executeValidationEvent("onValidateSuccess", context);
            }
            else {
                this.commandsExecutor.executeValidationEvent("onValidateFail", context);
            }
        }
        return Promise.resolve(validationResult);
    };
    ValidationMethodBase.prototype.getErrorMessage = function (context, defaultMessage) {
        if (context.errorMessage) {
            return ExpressionEvaluator_1.ExpressionEvaluator.renderTemplate(context.errorMessage, context.interaction);
        }
        return defaultMessage;
    };
    ValidationMethodBase.prototype.validResult = function () {
        return { valid: true };
    };
    ValidationMethodBase.prototype.invalidResult = function (errorMessage) {
        return {
            valid: false,
            errorMessage: errorMessage
        };
    };
    /**
     * Retrieves interaction object, regardless of whether the validation is used
     * as a question validation or as a page validation
     * @param context - validation context
     * @returns interaction
     */
    ValidationMethodBase.prototype.getInteraction = function (context) {
        if (context.interaction) {
            // used as a question validation
            return context.interaction;
        }
        // used as a page validation
        var pageContext = context;
        return pageContext.engine && pageContext.engine.getInteraction();
    };
    return ValidationMethodBase;
}());
exports.ValidationMethodBase = ValidationMethodBase;
//# sourceMappingURL=ValidationMethodBase.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/journey-services/dist/validations/ValidationMethodBase.js
// module id = 87
// module chunks = 0